export default __webpack_public_path__ + "static/media/tbl-prize2.b01b69ea.svg";